import { ArchivedIssuesList } from './ArchivedIssuesList';
import { PotentialIssuesHeader } from './PotentialIssuesHeader';
import React from 'react';
import { SnoozedIssuesList } from './SnoozedIssuesList';
import { VisibleIssuesList } from './VisibleIssuesList';

import { BASE_ROUTES, FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import { Navigate, Route, Routes } from 'react-router-dom';
import { SonarCard, ViewArea } from '@ui/general';

export const IssuesView: React.FC = () =>
	<ViewArea
		direction='vertical'
		id='issues-view'
		showPeriscopes>
		<SonarCard
			noSpacing
			title={ <PotentialIssuesHeader /> }>
			<Routes>
				<Route
					element={ <VisibleIssuesList /> }
					path='' />
				<Route
					element={ <ArchivedIssuesList /> }
					path={ BASE_ROUTES.ARCHIVED } />
				<Route
					element={ <SnoozedIssuesList /> }
					path={ BASE_ROUTES.SNOOZED } />
				<Route
					element={ <Navigate to={ FULL_ROUTES.ISSUES } /> }
					path='*' />
			</Routes>
		</SonarCard>
	</ViewArea>;

